
import type { PropType } from 'vue'
import type { EpbInlineTab } from './epb-inline-tabs.types'
import { computed, defineComponent, ref } from 'vue'
import EpbLoading from '../epb-loading/epb-loading.component.vue'

export default defineComponent({
  name: 'EpbInlineTabs',
  components: {
    EpbLoading,
  },
  props: {
    tabs: {
      type: Array as PropType<EpbInlineTab[]>,
      required: true,
    },
  },
  setup(props) {
    const activeTab = ref(props.tabs[0].id)
    const isSectionContentLoading = ref(false)

    const activeTabComponent = computed(() => {
      return props.tabs.find(tab => tab.id === activeTab.value).component
    })

    function handleIsLoading(isLoading: boolean): void {
      isSectionContentLoading.value = isLoading
    }

    function setActiveTab(tabId: EpbInlineTab['id']): void {
      activeTab.value = tabId
    }

    return {
      baseClass: 'epb-inline-tabs',
      activeTab,
      setActiveTab,
      activeTabComponent,
      isSectionContentLoading,
      handleIsLoading,
    }
  },
})
